import React from "react";

function CheckedBg({ width = 20, height = 20, fill = "#F8F6F6" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99935 1.6665C5.39935 1.6665 1.66602 5.39984 1.66602 9.99984C1.66602 14.5998 5.39935 18.3332 9.99935 18.3332C14.5993 18.3332 18.3327 14.5998 18.3327 9.99984C18.3327 5.39984 14.5993 1.6665 9.99935 1.6665ZM8.33268 14.1665L4.16602 9.99984L5.34102 8.82484L8.33268 11.8082L14.6577 5.48317L15.8327 6.6665L8.33268 14.1665Z"
        fill={fill}
      />
    </svg>
  );
}

export default CheckedBg;
